<template>
  <div ref="root">
    <div
      @click="showDropdown"
      class="tw:relative tw:cursor-pointer tw:border tw:rounded-lg tw:flex box-size-44 tw:items-center tw:px-3 tw:py-1 tw:pr-8 tw:h-[41px]"
      :class="show ? 'tw:border-blue-800' : 'tw:border-gray-500'"
    >
      <span class="tw:truncate tw:absolute tw:top-[3px] tw:text-xs tw:font-semibold">{{ $t(label) }}</span>
      <span class="tw:truncate tw:absolute tw:bottom-[3px] tw:text-sm tw:max-w-[160px]">
        {{ $t(value.label) }}
      </span>
      <ChevronRight class="tw:absolute tw:size-6" :class="show ? 'arrow-dropdown-open' : 'arrow-dropdown'" />
    </div>

    <div class="tw:relative tw:top-[5px] tw:z-20" v-if="show">
      <div class="tw:absolute tw:min-h-[50px] tw:left-0 tw:right-0 tw:bg-white tw:rounded dropdown-card">
        <ul class="tw:max-h-[180px] tw:overflow-auto">
          <li
            v-for="(option, index) in filteredOptions"
            :key="option.label"
            @click="onSelect(option)"
            :class="getOptionClass(isSelected(option), index)"
            class="tw:flex tw:items-center tw:justify-between tw:p-4 tw:hover:bg-blue-100 tw:hover:text-blue-800 tw:hover:cursor-pointer"
          >
            <span class="tw:flex tw:flex-row tw:items-center tw:text-sm tw:gap-2">
              {{ $t(option.label) }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onDeactivated, onUnmounted } from 'vue'

import ChevronRight from '@/components/icons/ChevronRight.svg?component'

const props = defineProps({
  options: Array,
  name: String,
  value: Object,
  label: String,
})

const searchQuery = ref('')
const root = ref(null)
const show = ref(false)
const filteredOptions = ref(props.options)
const showDropdown = () => {
  show.value = !show.value
}

const emit = defineEmits(['select'])

const isSelected = item => {
  return props.value.id === item.id
}

const onSelect = option => {
  emit('select', option)
  show.value = false
}

const getOptionClass = (selected, position) => {
  const classes = []
  if (position === 0) {
    classes.push('tw:rounded-t')
  } else if (props.options.length - 1 === position) {
    classes.push('tw:rounded-b')
  }
  if (selected) {
    classes.push('tw:text-blue-700 tw:bg-blue-100')
  }

  return classes.toString().replace(',', ' ')
}
watch(searchQuery, newSearchQuery => {
  const q = newSearchQuery.trim().toLocaleLowerCase()
  filteredOptions.value =
    q.length === 0
      ? props.options
      : props.options.filter(item => {
          const key = item.label ?? ''
          return key.includes(q)
        })
})
onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})
onUnmounted(() => document.removeEventListener('click', handleClickOutside))
onDeactivated(() => {
  document.removeEventListener('click', handleClickOutside)
})
const handleClickOutside = evt => {
  if (root?.value !== null && !root?.value?.contains(evt.target)) {
    show.value = false
  }
}
</script>

<style scoped>
.arrow-dropdown {
  top: 50%;
  transform: translateY(-45%) rotate(90deg);
  right: 6px;
  pointer-events: none;
}
.arrow-dropdown-open {
  top: 50%;
  transform: translateY(-45%) rotate(270deg);
  right: 6px;
  pointer-events: none;
}
.dropdown-card {
  box-shadow:
    0 2px 4px 0 rgba(63, 87, 189, 0.1),
    0 2px 10px 0 rgba(108, 112, 122, 0.15);
}
</style>
